import { FC, PropsWithChildren } from 'react';

import { AnimatePresence } from 'framer-motion';

export const AnimationContainer: FC<PropsWithChildren> = ({ children }) => (
  <AnimatePresence initial={false} mode='wait'>
    {children}
  </AnimatePresence>
);
